import { parseApiDateTime } from '@/helpers/parseApiDateTime';

export const dateTransform = (value) => {
  const rawDate = parseApiDateTime(value);
  if (!rawDate) {
    return '';
  }

  const date = rawDate.format('DD.MM.YYYY');
  const time = rawDate.format('HH:mm:ss');

  return (
    '<div>' +
    '<div><i class="bx bxs-calendar font-size-20 align-middle mr-1" aria-hidden="true"></i> ' +
    date +
    '</div>' +
    '<div><i class="bx bxs-time font-size-20 align-middle mr-1" aria-hidden="true"></i> ' +
    time +
    '</div>' +
    '</div>'
  );
};

export const dateTransformInline = (value) => {
  const rawDate = parseApiDateTime(value);
  if (!rawDate) {
    return '';
  }

  const date = rawDate.format('DD.MM.YYYY');
  const time = rawDate.format('HH:mm:ss');

  return (
    '<span class="ticket-datetime-one-line text-nowrap d-inline-flex align-items-center">' +
    '<i class="bx bxs-calendar font-size-20 align-middle mr-1" aria-hidden="true"></i>' +
    '<span>' +
    date +
    '</span>' +
    '<i class="bx bxs-time font-size-20 align-middle ml-2 mr-1" aria-hidden="true"></i>' +
    '<span>' +
    time +
    '</span>' +
    '</span>'
  );
};

export const dateTransformAlt = (value) => {
  const rawDate = parseApiDateTime(value);
  if (!rawDate) {
    return false;
  }

  const date = rawDate.format('DD.MM.YYYY');
  const time = rawDate.format('HH:mm:ss');

  return `${date} ${time}`;
};

export const deepClone = function (obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepClone);
  } else if (obj && typeof obj === 'object') {
    var cloned = {};
    var keys = Object.keys(obj);
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      cloned[key] = deepClone(obj[key]);
    }
    return cloned;
  } else {
    return obj;
  }
};

export const fn = (obj, key) => {
  if (Object.prototype.hasOwnProperty.call(obj, key)) return [obj];
  var results = [];
  Object.keys(obj).forEach(function (k) {
    var v = obj[k];
    if (v !== null && typeof v === 'object') {
      results = results.concat(fn(v, key));
    }
  });
  return results;
};

export const findValuesDeepByKey = (obj, key, res) => {
  if (res === undefined) res = [];
  if (obj && typeof obj === 'object') {
    Object.keys(obj).forEach(function (k) {
      if (k == key) res.push(obj[k]);
      if (obj[k] && typeof obj[k] === 'object') {
        findValuesDeepByKey(obj[k], key, res);
      }
    });
  }
  return res;
};
